import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * Renders the "Ai văzut recent" section by reading the recently viewed product
 * ids from localStorage and fetching this same section, re-rendered against a
 * `/search?q=id:X OR id:Y` URL, via the Section Rendering API. Mirrors the
 * technique already used for recently viewed products in the predictive search
 * dropdown (see assets/predictive-search.js).
 */
class RecentlyViewedComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    // Note: this section starts with the `hidden` class (display: none) until
    // populated, since we don't know whether there's anything to show before
    // reading localStorage. That means an IntersectionObserver on `this` would
    // never fire (display:none elements have no layout box and never
    // intersect), so loading is triggered directly here instead of lazily on
    // scroll - this is a small, cheap fetch, not worth deferring anyway.
    this.#loadRecentlyViewed();
  }

  #loadRecentlyViewed() {
    const { sectionId, currentProductId, maxProducts } = this.dataset;
    if (!sectionId) return;

    const ids = RecentlyViewed.getProducts()
      .filter((/** @type {string} */ id) => id !== currentProductId)
      .slice(0, Number(maxProducts) || 6);

    if (ids.length === 0) return;

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', ids.map((/** @type {string} */ id) => `id:${id}`).join(' OR '));

    sectionRenderer.renderSection(sectionId, { url }).catch((error) => {
      if (error?.name === 'AbortError') return;
      console.error('Recently viewed products error:', error);
    });
  }
}

if (!customElements.get('recently-viewed-component')) {
  customElements.define('recently-viewed-component', RecentlyViewedComponent);
}
